export const CONSTANTS = {
	CURRENT_TOKEN: 'CURRENT_TOKEN',
	TOKEN_EXPIRATION_DATE: 'TOKEN_EXPIRATION_DATE',
	REFRESH_TOKEN: 'REFRESH_TOKEN',
	CURRENT_USER: 'CURRENT_USER',
	VALID_EMAIL_REGEX: new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
};
